import React, { useEffect, useState } from 'react';
import { Button, Col, Drawer, Popconfirm, Row, Space, Table, Typography, Card, Tooltip } from 'antd';
import { openNotification } from '../../../utils';
import dayjs from 'dayjs';
import { APP_DATE_FORMAT } from 'config/constants';
import { listInspectionTasks, deleteInspectionTask } from '../services/inspection-taskService';
import InspectionTaskForm from './Form';
import TrashIcon from 'assets/icons/trash.svg';
import PenIcon from 'assets/icons/pen.svg';

export default function InspectionTaskList({ referenceId }: { referenceId?: number }){
  const [data, setData] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [open, setOpen] = useState(false);
  const [editingId, setEditingId] = useState<number | undefined>();
  
  const statusMap: Record<string, string> = {"PLANNED":"Planlandı","IN_PROGRESS":"Devam Ediyor","COMPLETED":"Tamamlandı","CANCELED":"İptal Edildi","POSTPONED":"Ertelendi","NO_SHOW":"Katılmadı / Gelmedi"};
  const fetchData = async () => {
    const res = await listInspectionTasks(page-1, pageSize, 'date,desc', referenceId !== undefined ? 'appointmentId.equals=' + referenceId : '');
    setData(res.content);
    setTotal(res.totalElements);
  };
  useEffect(() => { if(referenceId !== undefined) fetchData(); }, [page, pageSize, referenceId]);
  const openCreate = () => { setEditingId(undefined); setOpen(true); };
  const openEdit = (id:number) => { setEditingId(id); setOpen(true); };
  const handleClose = () => setOpen(false);
  const handleDelete = async (id:number) => {
    try {
      await deleteInspectionTask(id);
      openNotification('success', 'Başarılı', 'Denetim Görevi Silindi');
      fetchData();
    } catch (e) {
      openNotification('error', 'Hata', 'Denetim Görevi silme işlemi başarısız');
    }
  };
  const columns = [
    { title: 'Cihaz', dataIndex: 'measuringInstrumentInventory.measuringInstrument.name', sorter: true, render: (_: any, r: any) => r?.measuringInstrumentInventory?.measuringInstrument?.name + ' ' + r?.measuringInstrumentInventory?.serialNumber },
    { title: 'Parametre', dataIndex: 'attribute.name', sorter: true, render: (_: any, r: any) => r?.attribute?.name },
    {
      title: 'Uzman',
      dataIndex: 'account.firstName',
      sorter: true,
      render: (_: any, r: any) => {
        const account = r?.account || (r?.inspector ? r.inspector.account : null);
        const firstName = account?.firstName || '';
        const lastName = account?.lastName || '';
        return `${firstName} ${lastName}`.trim();
      },
    },
    { title: 'Durum', dataIndex: 'status', sorter: true, render: (v: any) => statusMap[v] ?? v },
    { title: 'Tarih/Saat', dataIndex: 'date', sorter: true, render: (v: string) => v ? dayjs(v).format(APP_DATE_FORMAT) : '' },
    { title: 'e-Devlet No', dataIndex: 'agreementNo', sorter: true },
    { title: 'İşlemler', render: (_:any, r:any) => (
      <Space>
        <Tooltip title='Düzenle'>
          <Button
            icon={<img src={PenIcon} alt="pen" className="icon" />}
            shape="circle"
            onClick={() => openEdit(r.id)}
            className="icon-button"
          />
        </Tooltip>
        <Popconfirm title='Sil?' onConfirm={() => handleDelete(r.id)}>
          <Tooltip title='Sil'>
            <Button
              icon={<img src={TrashIcon} alt="trash" className="icon" />}
              shape="circle"
              className="icon-button ml-12px"
            />
          </Tooltip>
        </Popconfirm>
      </Space>
    ) }
  ];
  return (
    <>
      
      <Card
        className='br-30px'
        title={<Typography.Title level={4} style={{ margin: 0 }}>Denetim Görevi</Typography.Title>}
        extra={<Button type='primary' onClick={openCreate}>Ekle</Button>}
      >
        <Table rowKey='id' dataSource={data} columns={columns} pagination={{ current: page, pageSize, total, onChange:(p,s)=>{setPage(p); setPageSize(s);} }} />
      </Card>
      <Drawer open={open} onClose={handleClose} destroyOnClose width={480} title={editingId ? 'Denetim Görevi Düzenle' : 'Denetim Görevi Oluştur'}>
        <InspectionTaskForm id={editingId} onSuccess={() => { handleClose(); fetchData();}} referenceId={referenceId} />
      </Drawer>
    </>
  );
}
